module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_faq_title.9969680.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_faq_title.png
// module id = 9dlN
// module chunks = 1 5